import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { apiConfig } from "../../app/api/apiConfig";
import { ReactComponent as LogoutWhitelabelQuotesIcon } from "../../app/assets/icons/signout-whitelabel-quotes-logo.svg";
import SignoutPageLayout from "../../layout/SignoutLayout/SignoutLayout";
import CustomButton from "../../components/CustomButton/CustomButton";
import { persistor, useAppDispatch, useAppSelector } from "../../redux/store";
import { logout } from "../../redux/slice/persist/authSlice";
import "./signout.scss";
import { signOut } from "aws-amplify/auth";

export default function Signout() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const auth = useAppSelector((state) => state.auth);
  const [error, setError] = useState<any>();

  useEffect(() => {
    async function fetchCognitoSignOut() {
      try {
        await signOut();
        persistor.purge();
        dispatch(logout());
        dispatch(apiConfig.util.resetApiState());
      } catch (e) {
        console.error(e);
        setError(e);
      }
    }
    if (!auth.isLoggedIn) {
      return navigate("/login");
    } else {
      fetchCognitoSignOut();
    }

    // eslint-disable-next-line
  }, [navigate, dispatch]);

  return (
    <>
      {!error ? (
        <div className="logout-page">
          <div className="text-center mt-xxl-5 mt-lg-4 mt-sm-3">
            <LogoutWhitelabelQuotesIcon />
          </div>
          <div className="logout-page-content">
            <SignoutPageLayout
              headerText="See you soon!"
              subHeaderText="You have been logged out of your account. Click the button below to log back in."
              isStep3={true}
              isLogoutPage
            >
              <CustomButton
                label="Log In"
                onClick={() => navigate("/login")}
                isSubmitting={false}
                type="submit"
              />
            </SignoutPageLayout>
          </div>

          <div className="logout-page-footer">
            <div onClick={() => window.open("/terms-and-conditions", "_blank")}>
              Terms & Conditions
            </div>
            <div onClick={() => window.open("/support", "_blank")}>Support</div>
            <div onClick={() => window.open("/customer-care", "_blank")}>
              Customer Care
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}
